import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import { Button, TextField } from '@material-ui/core';
// import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import { useHistory } from 'react-router';
import axios from 'axios';
import { useFormik } from 'formik';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@material-ui/core/Tooltip';
import SupportImage from '../../../assets/images/Support_image.png';
import token from '../../../config/token';
import { CommonConfig } from '../../../config/common-config';
import PreviewImage from '../../../assets/previewImage.png';
import PreviewModal from '../../../components/modal/previewModal';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';

const useStyles = makeStyles((theme) => ({
    supCardImg: {
        width: '100%',
        // height: '100%',
        // border: '1px solid black',
        // position: 'relative',
        '& img': {
            margin: '20px auto',
            display: 'block',
            // maxHeight: '100%',
            // maxWidth: '100%',
            // position: 'absolute',
            // top: '0',
            // bottom: '0',
            // left: '0',
            // right: '0',
            // margin: 'auto',
        },
    },
    heading: {
        fontFamily: 'Rubik',
        fontSize: '30px',
        fontWeight: 300,
        textAlign: 'center',
        color: '#515151',
        margin: '30px 0',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '100%',
    },
    btnspace: {
        width: '100%',
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '8px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
        pointerEvents: 'none',
    },
}));

export default function RaiseTicket({ letter, index, handleSave }) {
    const classes = useStyles();
    const history = useHistory();
    const tokens = token();
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    //console.log('USER DETAILS----', useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result.data));

    const clientName = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);

    const clientNameVal = clientName && clientName.data && clientName.data.firstName;

    const clientEmailId = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const clientEmailIdVal = clientEmailId && clientEmailId.data && clientEmailId.data.userName;

    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;

    const [issueTypeDropdownList, setIssueTypeDropdownList] = useState([]);
    const [requestdata, setrequestdata] = useState('');

    const [tokenListCount, setTokenList] = useState([]);
    const tokenListCountCheck = tokenListCount.content;

    const [URLValue, setURLValue] = useState();
    const [handleOpenNew, setHandleOpenNew] = useState(false);
    const [clearDataNew, setClearDataNew] = useState('');
    const [isfileInvalidNew, setIsfileInvalidNew] = useState('');
    const [selectedFileDataNew, setSelectedFileDataNew] = useState(null);
    const [filenameNew, setFilenameNew] = useState('');
    const [uploadSuccessfullyNew, setUploadSuccessfullyNew] = useState('');
    const [isDisableNew, setIsDisableNew] = useState(true);
    const [attachedFileNew, setAttachedFileNew] = useState('');

    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);

    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');

    ////console.log('tokenListCount ------>', tokenListCount);
    ////console.log('tokenListCount length ------>', tokenListCount.content !== null);
    //console.log('tokenListCountCheck---->',tokenListCountCheck);

    ////console.log('issueTypeDropdownList', issueTypeDropdownList);

    const handleClose = () => {
        setShowLoader(false);
        setSuccessPop(false);
        setErrorPop(false);
    };

    const formik = useFormik({
        initialValues: {
            issueRelTo: '',
            ticketMsgId: '',
        },
    });

    const handleSubmit = (values) => {
            ////console.log('test', formik)
            setShowLoader(true);

            const raiseTicketReqObj = {
                issuetypeId: values.issueRelTo,
                ticketStatusId: '1',
                clientName: clientNameVal,
                clientEmailId: clientEmailIdVal,
                attachDocuments: URLValue,
                message: values.ticketMsgId,
                // clientId: "234",
                // clientMobnumber: "+919094096573"
            };
            const axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: bearerToken,
                },
            };

            setrequestdata(raiseTicketReqObj);
            ////console.log('ON SUBMIT ---- REQ OBJ', raiseTicketReqObj);
            let baseURL = '';
            if (usertype === 'itec') {
                ////console.log('itec');
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket_itec`;
            } else {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket/${dbname}`;
            }
            axios
                .post(baseURL, raiseTicketReqObj, axiosConfig)
                .then((response) => {
                    ////console.log("SUBMIT RAISE TICKET", response.status);
                    if (response.status === 200) {
                        setShowLoader(false);
                        setSuccessPop(true);
                        setTimeout(() => {
                            history.push('/menu/support-ticketlist');
                        }, 3000);
                    }
                })
                .catch((error) => {
                    // console.error('There was an error!', error.response.data);
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });
        },
        handleModalClose = () => {
            setVisible(false);
        };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };

    const getTickets = () => {
        let baseURL = '';
        if (usertype === 'itec') {
            ////console.log('itec');
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket_all_itec/${dbname}`;
        } else {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket/${dbname}`;
        }
        axios
            .get(baseURL, tokens)
            .then((response) => {
                ////console.log("response TICKET LIST", response.data);
                if (response && response.data) {
                    setTokenList(response.data);
                }
                //----vipi------
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    const allIssueTypeOptions = (issueData) => {
        let tempArr = [];
        // if (usertype === 'ADMIN') {
        //     issueData.map((ele, i) => {
        //         if (ele.id !== 3) {
        //             tempArr.push(ele);
        //         }
        //     })
        // } else {
        //     tempArr = issueData;
        // }
        const issueOptionList = issueData.map((data) => <option value={data.id}>{data.issueType}</option>);
        return issueOptionList;
    };

    useEffect(() => {
        getIssueTypeDropdownList();
        getTickets();
    }, [userToken, tokens]);

    const getIssueTypeDropdownList = () => {
        const bearerToken = `Bearer ${userToken}`;
        let baseURL = '';
        if (usertype === 'itec') {
            ////console.log('itec');
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get-support-issuetypes_itec`;
        } else {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get-support-issuetypes/${dbname}`;
        }
        axios
            .get(baseURL, tokens)
            .then((response) => {
                ////console.log("GET ISSUE TYPE LIST", response.data);
                setIssueTypeDropdownList(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    const handleCloseNew = () => {
        setHandleOpenNew(false);
        setIsfileInvalidNew('');
        setUploadSuccessfullyNew('');
    };
    const handleClickNew = () => {
        setHandleOpenNew(true);
        setClearDataNew('');
        setFilenameNew('');
        setIsDisableNew(true);
    };
    const isFileUploadNew = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameNew(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidNew('');
                setIsDisableNew(false);
                if (selectorFiles[0].size / 1024 > 1024 * 2) {
                    setIsfileInvalidNew('Please select the file size less than 10MB');
                    setIsDisableNew(true);
                } else {
                    setSelectedFileDataNew(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidNew('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisableNew(true);
            }
        }
    };

    const fileUploadNew = () => {
        const data = new FormData();

        data.append('file', selectedFileDataNew);
        //console.log('Udhay', selectedFileDataNew);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    //console.log('Udhay data', response.data)
                    setURLValue(response.data);
                    const filename = response.data.substring(response.data.lastIndexOf('/') + 1);
                    setAttachedFileNew(filename);
                    setUploadSuccessfullyNew('Uploaded a file successfully');
                    setTimeout(() => {
                        handleCloseNew();
                    }, 500);
                    //console.log('UDHAYAYYYYY', filename)
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableNew(true);
                }
            });
    };

    const handleCancel = () => {
        history.push('/menu/support-ticketlist');
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Ticket raised successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}
            <Card className="client-card">
                <CardContent className="client-heading">
                    <Typography variant="h5">Raise Ticket</Typography>
                </CardContent>
                <CardContent>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="h4" className={classes.heading}>
                                    Have Some Questions?
                                </Typography>
                                <div className={classes.supCardImg}>
                                    {/* <Typography variant="h4" className={classes.heading}>Have Some Questions?</Typography> */}
                                    <img src={SupportImage} alt="Supportimage" />
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Grid container spacing={3} className="main-container">
                                    <Grid item xs={12} sm={12}>
                                        <FormControl fullWidth onSubmit={formik.handleSubmit}>
                                            <InputLabel className="lbl" htmlFor="issueRelTo" shrink>
                                                {' '}
                                                Issue related to <span style={{ color: '#ff0a047a' }}>*</span>
                                            </InputLabel>
                                            <Select
                                                native
                                                // inputProps={{
                                                //     name: 'issueRelTo',
                                                // }}
                                                id="issueRelTo"
                                                className="bottom"
                                                onChange={formik.handleChange}
                                                value={formik.values.issueRelTo}
                                            >
                                                <option value="">Select</option>
                                                {allIssueTypeOptions(issueTypeDropdownList)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormControl fullWidth>
                                            <InputLabel className="lbl" htmlFor="description" shrink>
                                                Message <span style={{ color: '#ff0a047a' }}>*</span>
                                            </InputLabel>
                                            <TextField
                                                id="ticketMsgId"
                                                // label="Message"
                                                className="marginTop"
                                                defaultValue="Enter Message"
                                                multiline
                                                rows={4}
                                                onChange={formik.handleChange}
                                                value={formik.values.ticketMsgId}
                                                inputProps={{ maxLength: 150 }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.btnspace}>
                                            <Button variant="outlined" color="primary" className={classes.button} onClick={handleClickNew}>
                                                Attach document
                                            </Button>
                                            <Dialog
                                                onClose={handleCloseNew}
                                                PaperProps={{
                                                    className: 'QandADailogBox',
                                                    style: { padding: '20px' },
                                                }}
                                                aria-labelledby="form-dialog-title"
                                                open={handleOpenNew}
                                                clear={clearDataNew}
                                            >
                                                <DialogTitle id="form-dialog-title">
                                                    Upload File
                                                    {/* <IconButton
                                                                aria-label="close"
                                                                className={classes.closeButton}
                                                                onClick={handleCloseNew}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton> */}
                                                </DialogTitle>
                                                <DialogContent style={{ textAlign: 'center' }}>
                                                    <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                        <i className="btnIcon">
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </i>{' '}
                                                        Add File
                                                        <input
                                                            onChange={(e) => isFileUploadNew(e, e.target.files)}
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                        />
                                                    </Button>
                                                    <p className="fileName">
                                                        {filenameNew.substring(0, 15)}
                                                        {filenameNew.length > 15 ? '...' : ''}
                                                    </p>
                                                </DialogContent>
                                                <p className="fileNameGreen">{uploadSuccessfullyNew}</p>
                                                <DialogActions className="paddingBtm txtCenter">
                                                    <Button
                                                        className={isDisableNew ? classes.disableBtn : 'btnBluepop'}
                                                        onClick={fileUploadNew}
                                                        variant="contained"
                                                        disabled={isDisableNew}
                                                        component="label"
                                                        color="default"
                                                    >
                                                        Upload
                                                    </Button>
                                                    <Button
                                                        className="btnBluepop"
                                                        onClick={handleCloseNew}
                                                        variant="contained"
                                                        component="label"
                                                        color="default"
                                                    >
                                                        Cancel
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </FormControl>
                                    </Grid>
                                    <span style={{ marginRight: '7px', paddingTop: '7px' }} className="fileName">
                                        {attachedFileNew.substring(0, 15)}
                                        {attachedFileNew.length > 15 ? '...' : ''}
                                    </span>
                                    {attachedFileNew ? (
                                        <span onClick={() => handlePreviewModal(URLValue)}>
                                            <Tooltip title="Preview">
                                                <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                            </Tooltip>
                                        </span>
                                    ) : null}
                                </Grid>
                            </Grid>
                        </Grid>
                        <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />
                    </form>
                </CardContent>
            </Card>
            <div className="footer-button">
                <ul>
                    <li>
                        <Button color="primary" className="buttonnext txt-cap" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </li>
                    <li>
                        <Button
                            color="primary"
                            type="submit"
                            className={
                                formik.values.issueRelTo.length && formik.values.ticketMsgId.length ? classes.button : classes.disableBtn
                            }
                            onClick={() => handleSubmit(formik.values)}
                        >
                            {/* <Button color="primary" className="buttonnext txt-cap" type="submit" onClick={navigate}> */}
                            Submit
                        </Button>
                    </li>
                </ul>
            </div>
            {/* <div className="footer-button">
                <ul>
                    <li>
                        <Button color="primary" className="buttonnext txt-cap" type="submit">
                            Cancel
                        </Button>
                    </li>
                    <li>
                        <Button color="primary" className="buttonnext txt-cap" type="submit"
                        className={classes.button}
                        onClick={() => formik.onSubmit}>
                        {/* <Button color="primary" className="buttonnext txt-cap" type="submit" onClick={navigate}> */}
        </>
    );
}
